import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { LicenseContactPersonManager } from './LicenseContactPerson';
import Button from '../../components/Button';
import { Input, InputGroup, Label } from '../../components/Form';
import Padder from '../../components/Padder';

import messages from './messages/LicenseUpdateControls';

const LicenseUpdateControlsWrap = styled.div`
  display: flex;
  flex-direction: column;

  > button {
    align-self: flex-start;
  }
`;

const UpdateDialog = styled.div`
  background: ${props => props.theme['grey-light']};
  padding: 8px;
`;

const propTypes = {
  company: PropTypes.object.isRequired,
  license: PropTypes.object.isRequired,
  toggleActiveState: PropTypes.func.isRequired,
  updateLicense: PropTypes.func.isRequired,
};

class LicenseUpdateControls extends Component {
  constructor(props) {
    super(props);

    // US short for update state
    this.US_CONF_CONTACT_PERSON = 'confirmation_contact_person';
    this.US_DIAL_CONTACT_PERSON = 'dialog_contact_person';
    this.US_CONF_CONTINUOUS = 'confirmation_continous';
    this.US_DIAL_CONTINUOUS = 'dialog_continuous';
    this.US_CONF_CUSTOMER_REF = 'confirmation_customer_reference';
    this.US_DIAL_CUSTOMER_REF = 'dialog_customer_reference';
    this.US_IDLE = 'idle';

    this.state = {
      customerReference: null,
      updateState: this.US_IDLE,
    };
  }

  setCustomerRef = evnt => {
    this.setState({ customerReference: evnt.target.value });
  }

  updateStateChanger = updateState => evnt => {
    evnt.preventDefault();
    const newState = { updateState };
    if (updateState === this.US_DIAL_CUSTOMER_REF) {
      const { customerReference } = this.state;
      if (customerReference === null) {
        newState.customerReference = this.props.license.customerReference;
      }
    } else if (updateState === this.US_IDLE) {
      newState.customerReference = null;
    }
    this.setState(newState, () => {
      if (updateState === this.US_IDLE) {
        this.props.toggleActiveState(false);
      } else {
        this.props.toggleActiveState(true);
      }
    });
  }

  dismissUpdate = (callback = () => {}) => {
    this.setState({
      updateState: this.US_IDLE,
      customerReference: null,
    }, () => {
      if (typeof callback === 'function') {
        callback();
      }
      this.props.toggleActiveState(false);
    });
  }

  updateCustomerRef = evnt => {
    evnt.preventDefault();
    const { customerReference } = this.state;
    const updatedLicense = this.props.license.clone();
    updatedLicense.customerReference = customerReference;
    this.dismissUpdate(
      () => this.props.updateLicense({
        license: this.props.license.data,
        updatedLicense: updatedLicense.data
      })
    );
  }

  toggleLicenseContinuous = evnt => {
    evnt.preventDefault();
    const updatedLicense = this.props.license.clone();
    updatedLicense.toggleContinuous();
    this.dismissUpdate(
      () => this.props.updateLicense({
        license: this.props.license.data,
        updatedLicense: updatedLicense.data
      })
    );
  }

  changeContactPerson = ({ contactPerson }) => {
    const updatedLicense = this.props.license.clone();
    updatedLicense.data.contactPerson = contactPerson;
    this.dismissUpdate(
      () => this.props.updateLicense({
        license: this.props.license.data,
        updatedLicense: updatedLicense.data
      })
    );
  }

  render = () =>
    <LicenseUpdateControlsWrap>
      {this.state.updateState === this.US_IDLE && (
        <React.Fragment>
          <Button
            id='license-update-customer-reference-button'
            onClick={this.updateStateChanger(this.US_DIAL_CUSTOMER_REF)}
          >
            <FormattedMessage
              {...messages.updateCustomerRefCTAButton}
            />
          </Button>
          <Padder />
          <Button
            id='license-toggle-continuous-button'
            onClick={this.updateStateChanger(this.US_DIAL_CONTINUOUS)}
          >
            {this.props.license.data.continuous && (
              <FormattedMessage
              {...messages.toggleLicenseContinuousOffCTAButton}
              />
            )}
            {!this.props.license.data.continuous && (
              <FormattedMessage
              {...messages.toggleLicenseContinuousOnCTAButton}
              />
            )}
          </Button>
          <Padder />
          <Button
            id='license-update-contact-person-button'
            onClick={this.updateStateChanger(this.US_DIAL_CONTACT_PERSON)}
          >
            <FormattedMessage
              {...messages.changeContactPersonCTAButton}
            />
          </Button>
        </React.Fragment>
      )}
      {this.state.updateState === this.US_DIAL_CUSTOMER_REF && (
        <UpdateDialog>
          <InputGroup>
            <Label htmlFor='license-customer-reference-input'>
              <FormattedMessage
                {...messages.updateCustomerRefDialogTitle}
              />
            </Label>
            <Input
              id='license-customer-reference-input'
              onChange={this.setCustomerRef}
              type='text'
              value={this.state.customerReference !== null
                ? this.state.customerReference
                : this.props.license.data.customerReference
              }
            />
          </InputGroup>
          <InputGroup horizontal>
            <Button
              id='license-update-customer-reference-do-button'
              onClick={this.updateStateChanger(this.US_CONF_CUSTOMER_REF)}
            >
              <FormattedMessage
                {...messages.updateCustomerRefDialYesButton}
              />
            </Button>
            <Button
              color='grey'
              id='license-update-customer-reference-cancel-button'
              kind='tertiary'
              onClick={this.updateStateChanger(this.US_IDLE)}
            >
              <FormattedMessage {...messages.updateCustomerRefDialNoButton} />
            </Button>
          </InputGroup>
        </UpdateDialog>
      )}
      {this.state.updateState === this.US_CONF_CUSTOMER_REF && (
        <UpdateDialog>
          <InputGroup>
            <Label>
              <FormattedMessage {...messages.updateCustomerRefConfirmTitle} />
            </Label>
            {this.state.customerReference}
          </InputGroup>
          <InputGroup horizontal>
            <Button
              id='license-update-customer-reference-confirm-yes-button'
              onClick={this.updateCustomerRef}
            >
              <FormattedMessage
                {...messages.updateCustomerRefConfYesButton}
              />
            </Button>
            <Button
              color='grey'
              id='license-update-customer-reference-confirm-no-button'
              kind='tertiary'
              onClick={this.updateStateChanger(this.US_DIAL_CUSTOMER_REF)}
            >
              <FormattedMessage {...messages.updateCustomerRefConfNoButton} />
            </Button>
          </InputGroup>
        </UpdateDialog>
      )}
      {this.state.updateState === this.US_DIAL_CONTINUOUS && (
        <UpdateDialog>
          <InputGroup>
            <Label as='span'>
              <FormattedMessage
                {...messages.toggleLicenseContinuousConfirmTitle}
              />
            </Label>
            {this.props.license.data.continuous && (
              <FormattedMessage
                {...messages.toggleLicenseContinuousOffDisc}
              />
            )}
            {!this.props.license.data.continuous && (
              <FormattedMessage
                {...messages.toggleLicenseContinuousOnDisc}
              />
            )}
          </InputGroup>
          <InputGroup horizontal>
            <Button
              id='license-toggle-continuous-confirm-yes-button'
              onClick={this.toggleLicenseContinuous}
            >
              <FormattedMessage
                {...messages.toggleLicenseContinuousConfYesButton}
              />
            </Button>
            <Button
              color='grey'
              id='license-toggle-continuous-confirm-no-button'
              kind='tertiary'
              onClick={this.updateStateChanger(this.US_IDLE)}
            >
              <FormattedMessage
                {...messages.toggleLicenseContinuousConfNoButton}
              />
            </Button>
          </InputGroup>
        </UpdateDialog>
      )}
      {this.state.updateState === this.US_DIAL_CONTACT_PERSON && (
        <UpdateDialog>
          <LicenseContactPersonManager
            buttons={{
              back: ({ working, onClick }) =>
                <Button
                  disabled={working}
                  color='grey'
                  id='license-update-contact-person-confirm-no-button'
                  kind='tertiary'
                  onClick={onClick}
                >
                  <FormattedMessage
                    {...messages.cancelChangeContactPersonButton}
                  />
                </Button>,
              continue: ({ working, onClick }) =>
                <Button
                  disabled={working}
                  id='license-update-contact-person-confirm-yes-button'
                  onClick={onClick}
                >
                  <FormattedMessage
                    {...messages.confirmChangeContactPersonButton}
                  />
                </Button>,
            }}
            companyId={this.props.company.id}
            initialContactPerson={this.props.license.data.contactPerson}
            onCancel={this.dismissUpdate}
            onSelect={this.changeContactPerson}
          />
        </UpdateDialog>
      )}
    </LicenseUpdateControlsWrap>;
}

LicenseUpdateControls.propTypes = propTypes;

export default LicenseUpdateControls;
